import { CreateDashboardUserSchema } from 'typings/dashboard_user';

export const actionsTypes = {
    CREATE_DASHBOARD_USER: 'DASHBOARD_USERS/CREATE_DASHBOARD_USER',
    CREATE_DASHBOARD_USER_SUCCESS:
        'DASHBOARD_USERS/CREATE_DASHBOARD_USER_SUCCESS',
    CREATE_DASHBOARD_USER_FAILURE:
        'DASHBOARD_USERS/CREATE_DASHBOARD_USER_FAILURE',
    GET_ALL_COMPANY_DASHBOARD_USERS:
        'DASHBOARD_USERS/GET_ALL_COMPANY_DASHBOARD_USERS',
    GET_ALL_COMPANY_DASHBOARD_USERS_SUCCESS:
        'DASHBOARD_USERS/GET_ALL_COMPANY_DASHBOARD_USERS_SUCCESS',
    GET_ALL_COMPANY_DASHBOARD_USERS_FAILURE:
        'DASHBOARD_USERS/GET_ALL_COMPANY_DASHBOARD_USERS_FAILURE',
    REMOVE_RECRUITER: 'DASHBOARD_USERS/REMOVE_RECRUITER',
    REMOVE_RECRUITER_SUCCESS: 'DASHBOARD_USERS/REMOVE_RECRUITER_SUCCESS',
    REMOVE_RECRUITER_FAILURE: 'DASHBOARD_USERS/REMOVE_RECRUITER_FAILURE',
};

export const actions = {
    createDashboardUser: (
        companyId: string,
        dashboardUser: CreateDashboardUserSchema,
    ) => ({
        type: actionsTypes.CREATE_DASHBOARD_USER,
        payload: { companyId, dashboardUser },
    }),
    getAllDashboardUsers: (companyId: string) => ({
        type: actionsTypes.GET_ALL_COMPANY_DASHBOARD_USERS,
        payload: { companyId },
    }),
    deleteRecruiterUsers: (companyId: string, userId: string) => ({
        type: actionsTypes.REMOVE_RECRUITER,
        payload: { companyId, userId },
    }),
};
